import { UAParser } from "ua-parser-js";

export function clientDeviceMetadata() {
  const parser = new UAParser();

  // Capture a small, serializable snapshot of the browser environment for the
  // reading submission. UAParser formats each section as a human-readable label.
  return {
    browser: cleanParserString(parser.getBrowser().toString()),
    device: cleanParserString(parser.getDevice().toString()),
    os: cleanParserString(parser.getOS().toString()),
  };
}

function cleanParserString(value) {
  // UAParser returns the literal string "undefined" when a section has no
  // details; store an empty value instead of persisting that placeholder.
  return value && value !== "undefined" ? value : "";
}
